const KEY = 'pending-join';
const TTL_MS = 15 * 60 * 1000;

/** Remember an invite code from /g/:code so we can join after the user
 *  authenticates — via guest login OR an OAuth round-trip. */
export function setPendingJoin(code: string) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ code, ts: Date.now() }));
  } catch { /* storage unavailable */ }
}

/** Consume the pending invite code (one-shot). Expired entries are dropped so
 *  a stale code can't yank a later, unrelated login into an old game. */
export function takePendingJoin(): string | null {
  let raw: string | null = null;
  try {
    raw = sessionStorage.getItem(KEY);
    if (raw !== null) sessionStorage.removeItem(KEY);
  } catch { /* storage unavailable */ }
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed.code === 'string' && parsed.code && Date.now() - parsed.ts < TTL_MS) {
      return parsed.code;
    }
    return null;
  } catch {
    // Legacy plain-string format from before the TTL wrapper.
    return raw;
  }
}
